import axios from "axios";
import { baseUrl } from "../urls";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("Token");
  const nextConfig = { ...config };

  nextConfig.baseURL = baseUrl;
  nextConfig.headers = nextConfig.headers ?? {};

  if (!(nextConfig.data instanceof FormData) && !nextConfig.headers["Content-Type"]) {
    nextConfig.headers["Content-Type"] = "application/json";
  }

  if (token) {
    nextConfig.headers.Authorization = `Bearer ${token}`;
  } else {
    delete nextConfig.headers.Authorization;
  }

  return nextConfig;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      error?.response?.data || error?.message || "Something went wrong"
    )
);

export default axiosInstance;
